import { useContext } from 'react';

import { DisplayConfigContext } from '../contexts/DisplayConfig.context.js';

export const useDisplayConfig = () => useContext(DisplayConfigContext);
